import { withErrorParsing } from '../../dialect-cloud-api/data-service-errors';
export class DataServiceDappNotificationTypes {
    constructor(api) {
        this.api = api;
    }
    async create(command) {
        const dto = await withErrorParsing(this.api.create(command));
        return {
            ...dto,
        };
    }
    async delete(id) {
        await withErrorParsing(this.api.delete(id));
    }
    async find(id) {
        const dto = await withErrorParsing(this.api.find(id));
        return {
            ...dto,
        };
    }
    async findAll() {
        const dtos = await withErrorParsing(this.api.findAll());
        return dtos.map((it) => ({
            ...it,
        }));
    }
    async patch(id, command) {
        const dto = await withErrorParsing(this.api.patch(id, command));
        return {
            ...dto,
        };
    }
}
//# sourceMappingURL=data-service-dapp-notification-types.js.map